import React from "react";
import { DollarOutlined } from "@ant-design/icons";
import { currencies } from "../../../constants/transport";

const Price = ({ order }) => {
  return (
    <div className="order-item__section order-item__price">
      <div className="order-item__section__icon">
        <DollarOutlined
          style={{
            fontSize: 16,
            color: "#333",
          }}
        />
      </div>
      <div className="order-item__section__content">
        {order.price} {currencies[order.currency]}
      </div>
    </div>
  );
};

export default Price;
